import parse, { domToReact } from 'html-react-parser'
import React from 'react'
import Highlighter from 'react-highlight-words'
import { Link } from 'react-router-dom'

import { LIST_NAME as Announcementslist } from '../../assets/ts/data/announcements'
import { LIST_NAME as KnowledgeBaselist } from '../../assets/ts/data/knowledge-base'
import { LIST_NAME as QuestionAndAnswerlist } from '../../assets/ts/data/q-and-a'
import { formatUTCDateToLocal } from '../../assets/ts/date-and-time/date-and-time'
import { openFile } from '../../assets/ts/files/files'
import { DocumentIconNames, removeTags } from '../../assets/ts/general/general'

interface InformationProps {
  activeClass?: string
  metaData: any
  page: any
  searchValue: string
}
const HighlightedText = ({ searchWords, text }) => {
  const options = {
    replace: ({ attribs, children }) => {
      if (!attribs) {
        return
      }
      return (
        <Highlighter
          autoEscape={true}
          highlightClassName='YourHighlightClass'
          searchWords={searchWords}
          textToHighlight={domToReact(children)}
        />
      )
    },
  }

  return parse(text, options)
}
const InformationPageList = ({ activeClass, metaData, page, searchValue }: InformationProps) => {
  const getListForPage = (page) => {
    if (page === 'Knowledgebase') {
      return KnowledgeBaselist
    }
    if (page === 'Announcements') {
      return Announcementslist
    }
    if (page === 'QuestionAndAnswer') {
      return QuestionAndAnswerlist
    }
  }
  return (
    <div
      className={`mb-2 pb-1 border-bottom1 ${activeClass}  ${page === 'Annoucements' ? 'kb' : ''}`}
    >
      <p className='m-0'>
        <Link
          className='title-color1 font-13 poppins-semibold  lineClamp1 maxfitcontent'
          title={metaData.Question}
          to={metaData?.link ? metaData?.link : '#'}
        >
          <Highlighter
            highlightClassName='YourHighlightClass'
            searchWords={[searchValue]}
            textToHighlight={metaData.Question}
          />
        </Link>
      </p>
      <p
        aria-label={metaData.Description}
        className='m-0 py-1 lineClamp3 sourcesanspro font-13 title-color19 maxfitcontent'
        // dangerouslySetInnerHTML={{ __html: metaData.Description }}
        tabIndex={0}
      >
        <HighlightedText searchWords={[searchValue]} text={removeTags(metaData.Description)} />
      </p>
      {metaData?.Attachments &&
        metaData?.Attachments[0]?.blobs.length > 0 &&
        metaData?.Attachments[0].blobs.map((blob) => (
          <a
            className='color-primary poppins-medium font-12 text-capitalize maxfitcontent'
            href='#'
            key={blob.fileName}
            onClick={() => openFile(blob, metaData.eKey, getListForPage(page))}
            tabIndex={0}
            title={blob.fileName}
          >
            <span className='color-primary'>
              <span className={`${DocumentIconNames(blob.fileName)} pe-2`}></span>
              <Highlighter
                highlightClassName='YourHighlightClass'
                searchWords={[searchValue]}
                textToHighlight={blob.fileName}
              />
            </span>
          </a>
        ))}
      {metaData.Answer && (
        <h3
          aria-label='Answer'
          className='m-0 sourcesansprosemibold title-color2 font-13 maxfitcontent py-1 pb-0'
          tabIndex={0}
        >
          Answer:
        </h3>
      )}
      {metaData.Answer && (
        <p
          aria-label={metaData.Answer}
          className='m-0 py-1 lineClamp3 sourcesanspro font-13 title-color19 maxfitcontent'
          // dangerouslySetInnerHTML={{ __html: metaData.Answer }}
          tabIndex={0}
        >
          <HighlightedText searchWords={[searchValue]} text={removeTags(metaData.Answer)} />
        </p>
      )}
      {metaData.ItemCreated && (
        <p
          aria-label={metaData.subcontent}
          className='m-0 sourcesanspro subtitle-color2 font-13 maxfitcontent'
          tabIndex={0}
        >
          <Highlighter
            highlightClassName='YourHighlightClass'
            searchWords={[searchValue]}
            textToHighlight={`Posted Date: ${formatUTCDateToLocal(
              metaData.ItemCreated
            )} | Section: ${metaData.Section} | Category: ${metaData.Category} | Tags: ${
              metaData.tags
            }`}
          />
        </p>
      )}
    </div>
  )
}
export default InformationPageList
